import { bufferToStream } from 'vscode/vscode/vs/base/common/buffer';
import 'vscode/vscode/vs/base/common/cancellation';

class RequestChannelClient {
    constructor(channel) {
        this.channel = channel;
    }
    async request(options, token) {
        const [res, buffer] = await this.channel.call('request', [options], token);
        return { res, stream: bufferToStream(buffer) };
    }
    async resolveProxy(url) {
        return this.channel.call('resolveProxy', [url]);
    }
    async loadCertificates() {
        return this.channel.call('loadCertificates');
    }
}

export { RequestChannelClient };
